import React, { useEffect, useState, useCallback } from 'react';
import { GroupsManagerModal } from '../shared/GroupsManagerModal';

const CFG = {
  drivers: { type: 'driver', field: 'driver_group', url: '/drivers', title: 'Manage Driver Groups', plural: 'drivers' },
  staff: { type: 'staff', field: 'staff_group', url: '/staff', title: 'Manage Staff Groups', plural: 'staff members' },
  passengers: { type: 'passenger', field: 'passenger_group', url: '/passengers', title: 'Manage Passenger Groups', plural: 'passengers' },
};

// Thin per-tab wrapper around the shared GroupsManagerModal (groups-ui-pattern.md §2.1).
// Fetches the tab's FULL people list on open (the page itself is paginated).
export const ManagePeopleGroupsModal = ({ open, onOpenChange, api, tab, onSaved }) => {
  const cfg = CFG[tab] || CFG.drivers;
  const [items, setItems] = useState([]);

  const refetchItems = useCallback(() => {
    api.get(cfg.url)
      .then((r) => setItems(Array.isArray(r.data) ? r.data : []))
      .catch(() => setItems([]));
  }, [api, cfg.url]);

  useEffect(() => {
    if (open) refetchItems();
  }, [open, refetchItems]);

  // Refresh our items copy after every save so allocate ticks reflect the
  // latest membership (matches Geofencing/Live Tracking live-list behavior).
  const handleSaved = useCallback(() => {
    refetchItems();
    onSaved?.();
  }, [refetchItems, onSaved]);

  return (
    <GroupsManagerModal
      open={open}
      onOpenChange={onOpenChange}
      api={api}
      apiBase="/people-groups"
      apiParams={{ group_type: cfg.type }}
      createPayloadExtra={{ group_type: cfg.type }}
      items={items}
      itemLabel={(p) => p.full_name || p.name || ''}
      itemSubLabel={(p) => p.email || p.employee_id || p.passenger_id || ''}
      itemIdField="id"
      itemGroupField={cfg.field}
      membershipMode="item_group_id"
      allocateEndpoints={{ add: 'add-items', remove: 'remove-items' }}
      title={cfg.title}
      itemLabelPlural={cfg.plural}
      onSaved={handleSaved}
      testIdPrefix="people-groups"
    />
  );
};
